import { render, staticRenderFns } from "./twitterFeed.vue?vue&type=template&id=08c36640"
import script from "./twitterFeed.vue?vue&type=script&lang=js"
export * from "./twitterFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports